<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Contract Types</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button @click="showAdd = true" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
                    <vs-button
                        @click="showViewForm"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="filterActive"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="contracttypes"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="showViewForm"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        </vx-card>
        <!-- Filter Data -->
        <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
            <div>
                <!-- <vs-input placeholder="Contract Type ID" v-model="filter.id" class="mt-4 mb-2 w-full" /> -->
                <vs-input
                    placeholder="Contract Type"
                    v-model="filter.contract_type"
                    class="mt-4 mb-2 w-full"
                />
                <vs-input
                    placeholder="Description"
                    v-model="filter.description"
                    class="mt-4 mb-2 w-full"
                />
            </div>
        </vs-prompt>

        <!-- Add Data -->
        <vs-prompt @accept="addData" title="Add" :active.sync="showAdd">
            <div>
                <vs-input
                    placeholder="Contract Type"
                    v-model="form.contract_type"
                    class="mt-4 mb-2 w-full"
                />
                <vs-input
                    placeholder="Description"
                    v-model="form.description"
                    class="mt-4 mb-2 w-full"
                />
            </div>
        </vs-prompt>

        <!-- View Data -->
        <vs-prompt buttons-hidden title="View" :active.sync="showView">
            <div>
                <vs-input
                    placeholder="Contract Type"
                    v-model="form.contract_type"
                    class="mt-4 mb-2 w-full"
                    :disabled="!editMode"
                />
                <vs-input
                    placeholder="Description"
                    v-model="form.description"
                    class="mt-4 mb-2 w-full"
                    :disabled="!editMode"
                />
            </div>
            <vs-row
                vs-align="flex-start"
                vs-type="flex"
                vs-justify="flex-end"
                vs-w="12"
                class="mt-5"
            >
                <vs-button color="primary" class="mr-2" @click="editMode = true">Edit</vs-button>
                <vs-button color="primary" @click="editData" :disabled="!editMode">Save</vs-button>
            </vs-row>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            contracttypes: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            showAdd: false,
            showView: false,
            editMode: false,
            filter: {
                id: "",
                contract_type: "",
                description: ""
            },
            form: {
                contract_type: '',
                description: ''
            }, 
            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("email", null);
            } else this.gridOptions.columnApi.setColumnPinned("email", "left");
        },
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this category?",
                accept: this.acceptAlert
            });
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete("master/contractypes/" + this.selectedId + "/destroy")
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Category deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected category was successfully deleted"
                    });
                })
                .catch(error => {
                    this.$vs.notify({
                        title: "Error",
                        text: "Error.",
                        color: "danger"
                    });
                })
                .then(() => {
                    this.fetchData();
                });
        },
        addData() {
        this.isLoading = true;
        this.$http
            .post("master/contracttypes/store", this.form)
            .then(res => {
            this.isLoading = false;
            this.showAddForm = false;
            this.fetchData();
            const message = res.data.message ? res.data.message : 'Success.'
            this.$vs.notify({
                color: "success",
                title: "Success",
                iconPack: "feather",
                icon: "icon-check",
                text: message
            });
            })
            .catch(error => this.handleError(error));
        },
        showViewForm() {
            this.isLoading = true;
            this.$http
                .get("master/contracttypes/" + this.selectedId)
                .then(res => {
                    this.form = res.data;
                })
                .catch(error => handleError(error))
                .then(() => {
                    this.showView = true;
                    this.isLoading = false;
                });
        },
        editData() {
            this.isLoading = true;
            this.$http
                .put(
                    "master/contracttypes/" + this.selectedId + "/update",
                    this.form
                )
                .then(res => {
                    this.editMode = false;
                    this.showView = false;
                    this.selectedId = null;
                    this.fetchData();
                    const message = res.data.message
                        ? res.data.message
                        : "Success.";
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message
                    });
                })
                .catch(error => handleError(error))
                .then(() => {
                    this.form = {};
                });
        },
        refreshData() {
            this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
        },
        fetchData() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            this.$http
                .post(
                    "master/contracttypes?page=" + this.currentPage,
                    this.filter
                )
                .then(resp => {
                    this.contracttypes = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                    this.isLoading = false;
                })
                .catch(resp => {
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.refreshData();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchData();
                });
        },
        filterData() {
            this.currentPage = 1;
            this.showFilter = false;
            this.fetchData();
        },
        filterActive() {
            this.showFilter = !this.showFilter;
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/contracttypes/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "ContractTypes-template.xlsx");
                });
        },
        uploadExcel(e) {
            let file = e.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/contracttypes/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    setTimeout(() => {
                        this.$vs.notify({
                            color: "success",
                            title: "Upload Success",
                            text: "Upload Data Inbound Successfully"
                        });
                    }, 500);
                })
                .catch(error => {
                    this.isLoading = false;
                    const message = error.response.data.message
                        ? error.response.data.message
                        : "Something went wrong";
                    this.$vs.notify({
                        color: "danger",
                        title: "Upload Failed",
                        text: message
                    });
                });
        },
        exportExcel() {
            this.isLoading = true;
            this.$http
                .post("master/contracttypes/report/exportexcel", this.filter, {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "ContractTypes-list-export.xlsx");
                });
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            // {
            //   headerName: "Contract ID",
            //   field: "id",
            //   width: 200,
            //   filter: true
            // },
            {
                headerName: "Contract Type",
                field: "contract_type",
                width: 120,
                filter: true
            },
            {
                headerName: "Description",
                field: "description",
                width: 120,
                filter: true
            }
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>